import React from 'react';

const Features = () => {
  const steps = [
    {
      number: "01.",
      title: "Create Your Profile",
      description: "Sign up in seconds and personalize your faith journey. Choose your interests, from prayer groups to daily scripture reading."
    },
    {
      number: "02.",
      title: "Find Your Community",
      description: "Discover groups that match your walk with Christ. Connect with local churches or global prayer warriors sharing your values."
    },
    {
      number: "03.",
      title: "Grow Together",
      description: "Engage in meaningful conversations, share testimonies, and support one another in a safe, moderated environment."
    }
  ];

  return (
    <section id="features" className="section features-section">
      <div className="container">
        <div className="section-title">
          <h2>How Faith Connect Works</h2>
          <p>Simple, powerful, and designed for your spiritual growth.</p>
        </div>
        
        <div className="features-content">
          <div className="features-visual">
            <div className="features-blob"></div>
            <div className="features-visual-card">
              <div style={{
                width: '100%',
                height: '100%',
                background: 'var(--bg-surface)',
                borderRadius: '24px',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Mock UI for Features */}
                <div style={{ height: '60px', background: 'var(--primary)', display: 'flex', alignItems: 'center', padding: '0 20px' }}>
                  <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: 'rgba(255,255,255,0.3)' }}></div>
                </div>
                <div style={{ padding: '20px', display: 'grid', gap: '12px' }}>
                  <div style={{ height: '80px', background: 'var(--bg-card)', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}></div>
                  <div style={{ height: '80px', background: 'var(--bg-card)', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}></div>
                  <div style={{ height: '80px', background: 'var(--bg-card)', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}></div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="features-list">
            {steps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-number">{step.number}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
            
            <div style={{ marginTop: '20px' }}>
              <a href="#hero" className="btn-primary">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
